import { Empty } from 'antd'

import Box from '~/core/Box'
import {
    docPhotosOnly,
    useInspectionType,
    BLACK_ALPHA_BOTTOM,
    NO_INSPECTION_DOCUMENTS,
    INSPECTION_TYPES,
} from '~/apps/consumer/components/PartViewerModal/logic'
import { InspectionReportType } from '~/apps/consumer/components/PartViewerModal/types'
import PartAttributes from '../PartAttributes'
import ThreadsConfiguredCard from '../PartAttributes/components/ThreadsConfiguredCard'
import TwoDdrawing from '../PartAttributes/components/TwoDdrawing'

import { DimensionalCard } from './DimensionalInspection/DimensionalComponents'
import { VisualCheck } from './VisualInspection/VisualCheck'
import PartPhoto from './AttachmentTypeComponents/PartPhoto'
import Certificate from './AttachmentTypeComponents/Certificate'
import AdditionalFiles from './AttachmentTypeComponents/AdditionalFiles'
import BoundingBox from './BoundingBox'

export default function InspectionReport(props: InspectionReportType) {
    const {
        additionalDocs,
        boundingBox,
        certificates,
        fictiv5s,
        holesCount,
        inspectionTypes,
        isImOrder,
        manufacturingDrawing,
        materialName,
        photos,
        processName,
        processes,
        placement,
        quantity,
        selectedInspectionDocument,
        setInspectionDocumentIdx,
        setActivePage,
        shouldShowThreadTag,
        tapsCount,
        twoDdrawing,
    } = props

    const inspectionType = useInspectionType(inspectionTypes)
    const numF5Images = fictiv5s?.filter(docPhotosOnly).length || 0
    const numPrevItems = numF5Images + (photos?.length || 0)

    return (
        <>
            {processName && Boolean(quantity) && materialName && (
                <PartAttributes
                    quantity={quantity || 0}
                    processName={processName}
                    materialName={materialName}
                    processes={processes || []}
                    isInspectionReportEnabled
                    isImOrder={isImOrder}
                />
            )}
            {shouldShowThreadTag && (
                <>
                    {twoDdrawing && (
                        <TwoDdrawing
                            placement={placement}
                            twoDdrawing={twoDdrawing}
                        />
                    )}
                    {(holesCount || 0) > 0 && (
                        <ThreadsConfiguredCard
                            holesCount={holesCount}
                            tapsCount={tapsCount}
                            placement={placement}
                            setActivePage={setActivePage}
                        />
                    )}
                </>
            )}
            {boundingBox && <BoundingBox boundingBox={boundingBox} />}
            {inspectionType === INSPECTION_TYPES.DIMENSIONAL_INSPECTION ? (
                <DimensionalCard
                    fictiv5s={fictiv5s}
                    manufacturingDrawing={manufacturingDrawing}
                    selectedInspectionDocument={selectedInspectionDocument}
                    setInspectionDocumentIdx={setInspectionDocumentIdx}
                />
            ) : (
                <VisualCheck placement={placement} />
            )}
            {fictiv5s?.length <= 0 &&
                photos?.length <= 0 &&
                additionalDocs?.length <= 0 && (
                    <Box
                        borderBottom={BLACK_ALPHA_BOTTOM}
                        direction="col"
                        padding="26px 0 11px"
                    >
                        <Empty description={NO_INSPECTION_DOCUMENTS} />
                    </Box>
                )}
            {Boolean(photos?.length) && (
                <Box direction="col" padding="16px 0">
                    <PartPhoto
                        photos={photos}
                        numF5Images={numF5Images}
                        selectedInspectionDocument={selectedInspectionDocument}
                        setInspectionDocumentIdx={setInspectionDocumentIdx}
                    />
                </Box>
            )}
            {Boolean(certificates?.length) && (
                <Box
                    borderTop={BLACK_ALPHA_BOTTOM}
                    direction="col"
                    padding="16px 0"
                >
                    <Certificate
                        certificates={certificates}
                        selectedInspectionDocument={selectedInspectionDocument}
                        numPrevItems={numPrevItems}
                        setInspectionDocumentIdx={setInspectionDocumentIdx}
                    />
                </Box>
            )}
            {Boolean(additionalDocs?.length) && (
                <Box direction="col" padding="16px 0">
                    <AdditionalFiles
                        placement={placement}
                        additionalDocs={additionalDocs}
                    />
                </Box>
            )}
        </>
    )
}
